<template>
  <div class="PaymentRecord">
    <!-- 余额查询 消费合计 剩余合计 -->
    <el-row>
      <el-form
        :inline="true"
        :model="addForm"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="老人姓名">
          <el-input
            v-model="addForm.oldName"
            placeholder="请输入老人姓名"
            clearable
            @keyup.enter.native.prevent="enterSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="老人身份证">
          <el-input
            v-model="addForm.oldIdCard"
            placeholder="请输入老人身份证"
            clearable
            @keyup.enter.native.prevent="enterSearch"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
           type="primary"
            icon="el-icon-search"
            plain
            @click="queryTable"
            >查询</el-button
          >
          <el-button
           type="warning"
            icon="el-icon-plus"
            plain
            @click="oldCharge"
            >缴费</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width: 100%"
      >
        <el-table-column
          prop="oldName"
          label="老人姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oldAge"
          label="年龄"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oldIdCard"
          label="身份证号"
          align="center"
          min-width="160px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="remainder"
          label="账户余额"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="payFee"
          label="累计缴费金额"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="giftFee"
          label="赠送金额"
          align="center"
        ></el-table-column> -->
        <el-table-column
          label="欠缴金额"
          align="center"
          prop="option"
        >
        <template slot-scope="scope">
          <p v-if="scope.row.remainder>=0">0</p>
          <p v-else style="color:red">{{0-scope.row.remainder}}</p>
        </template>
      </el-table-column>
        <el-table-column prop="option" label="详情" min-width="130px" align="center">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="showConsumption(scope.row)"
              >费用明细</el-button>
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="showRecharge(scope.row)"
              >缴费记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      class="fenye"
      background
      layout="total,prev, pager, next"
      :total="total"
      :current-page.sync="pageNum"
      @current-change="changePage"
      align="center"
    ></el-pagination>

    <el-dialog title="缴费" :visible.sync="dialogChargeVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" width="420px">
        <el-form ref="form" :model="chargeForm">
          <el-form-item label="长者姓名" :label-width="formLabelWidth" prop="oldmanId">
            <el-autocomplete v-model.trim="chargeForm.oldName" auto-complete="off" placeholder="搜索老人姓名"
              :fetch-suggestions="querySearchAsync" @select="handleOlderSelect" style="width: 240px">
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="身份证号" :label-width="formLabelWidth">
            <p>{{chargeForm.oldIdCard}}</p>
          </el-form-item>
          <el-form-item label="支付方式" :label-width="formLabelWidth" prop="chargeType">
            <el-select v-model="chargeForm.chargeType" placeholder="请选择" style="width: 240px">
              <el-option label="现金支付" value="1"> </el-option>
              <el-option label="刷卡支付" value="2"> </el-option>
              <el-option label="移动支付" value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票据号" :label-width="formLabelWidth">
            <el-input
            v-model.trim="chargeForm.ticket"
            style="width: 240px"
          ></el-input>
          </el-form-item>
          <el-form-item label="费用项目" :label-width="formLabelWidth">
            <el-input
            v-model.trim="chargeForm.typeName"
            style="width: 240px"
          ></el-input>
          </el-form-item>
          <!-- //缴费的文字 -->
          <el-form-item label="缴费日期" :label-width="formLabelWidth" prop="chargeDay">
            <el-date-picker
              v-model="chargeForm.chargeDay"
              type="date"
              style="width: 240px"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="缴费金额" :label-width="formLabelWidth" prop="rechargePrice">
            <el-input v-model.trim="chargeForm.rechargePrice" placeholder="请输入充值金额" @input="inputChange1" style="width: 240px">
              <span slot="suffix">/ 元 </span>
            </el-input>
          </el-form-item>
          
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogChargeVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="chargeLoading">确 定</el-button>
        </div>
    </el-dialog>

     <!-- 消费记录 -->
     <el-dialog title="消费记录" width="60%" :visible.sync="dialogConsumption" :close-on-click-modal="false">
      <el-table :data="consumptionRecordList" style="width: 100%" :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" 
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }">
        <el-table-column
            prop="oldName"
            label="老人姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="费用类型"
            :formatter="formatType"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="projectType"
            label="项目类别"
            :formatter="formattype2"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="projectName"
            label="费用项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="consumptionFee"
            label="金额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createdTime"
            label="发生时间"
            align="center"
            width="180px"
          ></el-table-column>
      </el-table>
      <el-pagination background @current-change="consumptionPageChange" :current-page="consumptionPage"
        layout="total, prev, pager, next" :total="consumptionTotal" :page-size="pageSize" align="center"
        class="fenye"></el-pagination>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="dialogConsumption = false">关 闭</el-button>
      </div>
    </el-dialog>

    
     <!-- 缴费记录 -->
     <el-dialog title="缴费记录" width="60%" :visible.sync="dialogRecharge" :close-on-click-modal="false">
      <el-table :data="consumptionRecordList" style="width: 100%" :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }">
        <el-table-column
        prop="oldName"
        label="老人姓名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="projectType"
        label="缴费方式"
        :formatter="formattype2"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="projectName"
        label="费用项目"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ticket"
        label="票据号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="consumptionFee"
        label="缴费金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createdTime"
        label="缴费时间"
        align="center"
      ></el-table-column>
      </el-table>
      <el-pagination background @current-change="rechargePageChange" :current-page="rechargePage"
        layout="total, prev, pager, next" :total="consumptionTotal" :page-size="pageSize" align="center"
        class="fenye"></el-pagination>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="dialogRecharge = false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      tableData: [], //老人列表数据
      addForm: {
        oldName: "", //搜索查询老人
        oldIdCard: "", //搜索查询老人身份证
      },
      dialogChargeVisible:false,
      dialogConsumption:false,
      dialogRecharge:false,
      consumptionRecordList:[],
      consumptionPage:1,
      rechargePage:1,
      consumptionTotal:0,
      quertForm:{},
      formLabelWidth:"100px",
      chargeForm:{},
      chargeLoading:false,
      //分页
      total: 0,
      pageNum: 1,
      pageSize: 10, //分页总数
      checkBill: [],
    };
  },
  methods: {
    showConsumption(row){
      this.consumptionPage = 1;
      this.consumptionTotal=0;
      this.dialogConsumption = true;
      this.consumptionRecordList = [];
      this.quertForm = {
        oldId:row.oldId,
        statusList:[0,1,2,3,4,5,6,7,8]
      }
      this.queryConsumptionList();
    },
    showRecharge(row){
      this.rechargePage = 1;
      this.consumptionTotal=0;
      this.dialogRecharge = true;
      this.consumptionRecordList = [];
      this.quertForm = {
        oldId:row.oldId
      }
      this.queryRechargeList();
    },
    consumptionPageChange(val){
      this.consumptionPage = val;
      this.queryConsumptionList();
    },
    rechargePageChange(val){
      this.rechargePage = val;
      this.queryRechargeList();
    },
    queryConsumptionList(){
        let param = {
          oldId: this.quertForm.oldId,
          statusList:this.quertForm.statusList,
          pageNum: this.consumptionPage,
          pageSize: this.pageSize,
        };
        this.$postJson("omc/account/queryConsumptionRecord", param).then((res) => {
          this.consumptionRecordList = res.result.list; //列表数据
          this.consumptionTotal = Number(res.result.total); //页码total
        });
    },
    queryRechargeList(){
      let param = {
          oldId: this.quertForm.oldId,
          pageNum: this.rechargePage,
          pageSize: this.pageSize,
        };
        this.$postJson("omc/account/queryRechargeRecord", param).then((res) => {
          this.consumptionRecordList = res.result.list; //列表数据
          this.consumptionTotal = Number(res.result.total); //页码total
        });
    },
    formattype2(row){
      if (row.type == 5){
        if (row.projectType == "1"){
          return "现金支付";
        }else if (row.projectType == "2"){
          return "刷卡支付";
        }else if (row.projectType == "3"){
          return "移动支付";
        }else{
          return row.projectType;
        }
      }else{
        return row.projectType;
      }
    }
    ,
    formatType(row){
        // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
        if(row.type == 0){
          return "按天消费";
        }else if(row.type == 1){
          return "按月消费";
        }else if(row.type == 2){
          return "单次服务收费";
        }else if(row.type == 5){
          return "充值";
        }else if(row.type == 6){
          return "请假退费";
        }else if(row.type == 7){
          return "出院退费";
        }else if(row.type == 8){
          return "服务订单退费";
        }else{
          return "其他费用";
        }
      },
    inputChange1(val) {
      //限制输入数字和两位小数;
      this.chargeForm.rechargePrice = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
     /* 
      模糊查询老人
      */
      querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.chargeForm.oldmanId = item.oldmanId;
      this.chargeForm.oldIdCard = item.oldIdCard;
    },
    oldCharge(){
      this.dialogChargeVisible = true;
      this.chargeForm = {
        oldmanId:"",
        rechargePrice:"",
        ticket:"",
        typeName:"",
        chargeType:"",
        chargeDay:util.formatDate.format(new Date(), "yyyy-MM-dd"),
      }
    },
    submitForm(){
      if(this.chargeForm.oldmanId == null || this.chargeForm.oldmanId == ''){
        return;
      }
      if(this.chargeForm.rechargePrice == null || this.chargeForm.rechargePrice == ''){
        return;
      }
      if(this.chargeForm.chargeType == null || this.chargeForm.chargeType == ''){
        return;
      }
      this.chargeLoading = true;
      console.log(this.chargeForm);
      let chargeType = "";
      if(this.chargeForm.chargeType == '1'){
        chargeType = "现金支付";
      }else if(this.chargeForm.chargeType == '2'){
        chargeType = "刷卡支付";
      }else {
        chargeType = "移动支付";
      }
      var params = {
        oldmanId:this.chargeForm.oldmanId,
        rechargePrice: this.chargeForm.rechargePrice,
        chargeType: chargeType,
        ticket: this.chargeForm.ticket,
        typeName: this.chargeForm.typeName,
        chargeDay: this.chargeForm.chargeDay
      }
      this.$postJson("omc/account/rechargeOldAccount", params).then((res) => {
        console.log(res, "res");
        if(res.code == 200){
          this.chargeLoading = false;
          this.dialogChargeVisible = false;
          this.queryPayList();
          this.$message({ message: "缴费成功", type: "success" });
        }else{
          this.chargeLoading = false;
          this.$message({ message: res.message, type: "error" });
        }
      });

    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //查询欠费列表
    queryPayList() {
      let param = {
        oldName: this.addForm.oldName,
        oldIdCard: this.addForm.oldIdCard,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/account/queryWithPage", param).then((res) => {
        this.tableData = res.result.list; //列表数据
        this.total = Number(res.result.total); //页码total
      });
    },
    //回车enter回车查询
    enterSearch(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryPayList();
      }
    },
    //搜索查询搜索查询
    queryTable() {
      this.pageNum = 1;
      this.queryPayList();
    },
    //分页
    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },
  },
  //自动刷新
  mounted() {
    this.queryPayList(); //刷新欠费列表的数据
  },
};
</script>
<style lang="scss" scoped>
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}
.are {
  color: #369a52;
}
.no {
  color: red;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
